export default "__VITE_PUBLIC_ASSET__d0543247__"